import Vimeo from '@vimeo/player';

function pauseOtherVimeoInstances(currentIframe) {
    document.querySelectorAll('iframe[data-vimeo-id]').forEach(iframe => {
        if (iframe !== currentIframe) {
            try {
                const player = new Vimeo(iframe);
                player.getMuted().then(isMuted => {
                    if (!isMuted) {
                        player.pause();
                        player.setMuted(true);
                    }
                });
            } catch (error) {
                console.error('Error pausing other Vimeo instances:', error);
            }
        }
    });
}

function handleExperienceCard() {
    const el = document.querySelector('.section-experience-card');
    const video = el.querySelector('.video');
    if (!video) return;
    const playButton = video.querySelector('.icon-play');
    const iframe1 = video.querySelector('#vimeo-video-autoplay');
    const iframe2 = video.querySelector('#vimeo-video-inline');

    // Swap nitro-lazy-src to src
    if (iframe1) {
        const autoplayLazySrc = iframe1.getAttribute('nitro-lazy-src');
        console.log(autoplayLazySrc);

        if (autoplayLazySrc) {
            iframe1.setAttribute('src', autoplayLazySrc);
            console.log(iframe1);
            iframe1.removeAttribute('nitro-lazy-src');
        }
    }
    if (iframe2) {
        const inlineLazySrc1 = iframe2.getAttribute('nitro-lazy-src');
        const inlineLazySrc2 = iframe2.getAttribute('nitro-og-src');
        const inlineLazySrc = inlineLazySrc1 || inlineLazySrc2;
        console.log(inlineLazySrc);

        if (inlineLazySrc) {
            iframe2.setAttribute('src', inlineLazySrc);
            console.log(iframe2);
            iframe2.removeAttribute('nitro-lazy-src');
            iframe2.removeAttribute('nitro-og-src');
        }
    }

    const vimeoId = iframe1.getAttribute('data-vimeo-id');

    let player = null;

    try {
        player = new Vimeo(iframe1, {
            id: vimeoId,
            autoplay: true,
            autopause: false,
            muted: true,
            loop: true,
            unmute_button: false,
        });

        player.play();
    } catch (error) {
        console.error('Error initializing Vimeo player:', error);
    }

    video.addEventListener('click', function () {
        playButton.style.display = 'none';

        iframe1.classList.add('hidden');
        iframe2.classList.add('active');

        try {
            player = new Vimeo(iframe2);
            player.setCurrentTime(0);
            player.setMuted(false);
            player.play();
            pauseOtherVimeoInstances(iframe2);
        } catch (error) {
            console.error('Error initializing Vimeo player:', error);
        }
    }, { once: true });
}

if (document.querySelector('.section-experience-card')) {
    handleExperienceCard();
}